/**
 * @component PageHeader
 * @description Einheitlicher Seitenkopf mit Titel, optionalem Untertitel
 * und Aktionsbereich (Buttons, Filter). Standardmaessig mit mb-6.
 *
 * @prop {string}    title      - Seitentitel (h1)
 * @prop {string}    [subtitle] - Optionaler Untertitel
 * @prop {ReactNode} [actions]  - Optionale Aktionselemente (rechts)
 * @prop {string}    [className] - Optionale CSS-Klassen
 * @usage Verwendet als Kopfzeile auf allen Hauptseiten
 */
export function PageHeader({ title, subtitle, actions, className = '' }) {
  return (
    <div className={`flex items-center justify-between mb-6 ${className}`}>
      <div>
        <h1 className="text-xl font-bold tracking-tight text-content">{title}</h1>
        {subtitle && <p className="text-xs text-[var(--text-secondary)] mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
